module.exports = __webpack_public_path__ + "public/SiteIcons/home.png?11a1277d";